<div class="relative" [ngClass]="{
    'layout-wrapper-closed': isSidebarOpen === false,
    'layout-wrapper': isSidebarOpen === true,
  }">
    <div class="layout-topbar">
        <top-technology-header></top-technology-header>
    </div>
    <div class="layot_dv">
        <top-technology-side-bar></top-technology-side-bar>

        <div class="layout-main-container">
            <div class="layout-main">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>